import { render, staticRenderFns } from "./FechoCaixa.vue?vue&type=template&id=448281fc&scoped=true&"
import script from "./FechoCaixa.vue?vue&type=script&lang=js&"
export * from "./FechoCaixa.vue?vue&type=script&lang=js&"
import style0 from "./FechoCaixa.vue?vue&type=style&index=0&id=448281fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448281fc",
  null
  
)

export default component.exports